import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ClarityPlanCard from "components/molecules/PaidPlanCards/ClarityPlanCard";
import { UserPlan } from "types/user";
import GuidancePlanCard from "components/molecules/PaidPlanCards/GuidancePlanCard";
import { Container } from "./styles";
import { Props } from "./types";
import Modal from "../../../../../components/atoms/Modal";

const BookSessionModal = ({
  isVisible,
  onClose,
  userPlan,
  handleGoToPayments,
}: Props) => {
  const { t } = useTranslation();

  const showClarityPricePlan = useMemo(() => {
    if (userPlan === null) {
      return false;
    }
    return (
      userPlan === undefined ||
      [UserPlan.free, UserPlan.essentials].includes(userPlan as UserPlan)
    );
  }, [userPlan]);

  const showGuidancePricePlan = useMemo(() => {
    if (userPlan === null) {
      return false;
    }
    return (
      userPlan === undefined ||
      [UserPlan.free, UserPlan.essentials, UserPlan.clarity].includes(
        userPlan as UserPlan
      )
    );
  }, [userPlan]);

  return (
    <div>
      <Modal
        isOpen={isVisible}
        onClose={onClose}
        title={t("student.bookExpertSession")}
        size="wide"
      >
        <Container>
          {showClarityPricePlan && (
            <ClarityPlanCard
              price={130}
              handleGoToPayments={() => handleGoToPayments("clarity-add-on")}
            />
          )}
          {showGuidancePricePlan && (
            <GuidancePlanCard
              price={250}
              handleGoToPayments={() => handleGoToPayments("guidance-add-on")}
            />
          )}
        </Container>
      </Modal>
    </div>
  );
};

export default BookSessionModal;
